import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "icon-view-box" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-view__mask",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 128 128"
}, [
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", {
      id: "clipArea",
      clipPathUnits: "objectBoundingBox"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M1,0.5 L1,0.535 L1,0.553 L1,0.568 L1,0.58 L0.999,0.592 L0.999,0.603 L0.999,0.613 L0.999,0.622 L0.998,0.631 L0.998,0.64 L0.997,0.648 L0.997,0.656 L0.996,0.664 L0.996,0.671 L0.995,0.679 L0.994,0.686 L0.993,0.693 L0.993,0.699 L0.992,0.706 L0.991,0.712 L0.99,0.718 L0.989,0.724 L0.988,0.73 L0.987,0.736 L0.986,0.742 L0.985,0.748 L0.983,0.753 L0.982,0.759 L0.981,0.764 L0.979,0.769 L0.978,0.774 L0.977,0.779 L0.975,0.784 L0.974,0.789 L0.972,0.794 L0.97,0.799 L0.969,0.803 L0.967,0.808 L0.965,0.813 L0.963,0.817 L0.961,0.821 L0.96,0.826 L0.958,0.83 L0.956,0.834 L0.954,0.838 L0.951,0.842 L0.949,0.846 L0.947,0.85 L0.945,0.854 L0.943,0.858 L0.94,0.862 L0.938,0.865 L0.935,0.869 L0.933,0.872 L0.93,0.876 L0.928,0.879 L0.925,0.883 L0.922,0.886 L0.92,0.89 L0.917,0.893 L0.914,0.896 L0.911,0.899 L0.908,0.902 L0.905,0.905 L0.902,0.908 L0.899,0.911 L0.896,0.914 L0.893,0.917 L0.89,0.92 L0.886,0.922 L0.883,0.925 L0.879,0.928 L0.876,0.93 L0.872,0.933 L0.869,0.935 L0.865,0.938 L0.862,0.94 L0.858,0.943 L0.854,0.945 L0.85,0.947 L0.846,0.949 L0.842,0.951 L0.838,0.954 L0.834,0.956 L0.83,0.958 L0.826,0.96 L0.821,0.961 L0.817,0.963 L0.813,0.965 L0.808,0.967 L0.803,0.969 L0.799,0.97 L0.794,0.972 L0.789,0.974 L0.784,0.975 L0.779,0.977 L0.774,0.978 L0.769,0.979 L0.764,0.981 L0.759,0.982 L0.753,0.983 L0.748,0.985 L0.742,0.986 L0.736,0.987 L0.73,0.988 L0.724,0.989 L0.718,0.99 L0.712,0.991 L0.706,0.992 L0.699,0.993 L0.693,0.993 L0.686,0.994 L0.679,0.995 L0.671,0.996 L0.664,0.996 L0.656,0.997 L0.648,0.997 L0.64,0.998 L0.631,0.998 L0.622,0.999 L0.613,0.999 L0.603,0.999 L0.592,0.999 L0.58,1 L0.568,1 L0.553,1 L0.535,1 L0.5,1 L0.465,1 L0.447,1 L0.432,1 L0.42,1 L0.408,0.999 L0.397,0.999 L0.387,0.999 L0.378,0.999 L0.369,0.998 L0.36,0.998 L0.352,0.997 L0.344,0.997 L0.336,0.996 L0.329,0.996 L0.321,0.995 L0.314,0.994 L0.307,0.993 L0.301,0.993 L0.294,0.992 L0.288,0.991 L0.282,0.99 L0.276,0.989 L0.27,0.988 L0.264,0.987 L0.258,0.986 L0.252,0.985 L0.247,0.983 L0.241,0.982 L0.236,0.981 L0.231,0.979 L0.226,0.978 L0.221,0.977 L0.216,0.975 L0.211,0.974 L0.206,0.972 L0.201,0.97 L0.197,0.969 L0.192,0.967 L0.187,0.965 L0.183,0.963 L0.179,0.961 L0.174,0.96 L0.17,0.958 L0.166,0.956 L0.162,0.954 L0.158,0.951 L0.154,0.949 L0.15,0.947 L0.146,0.945 L0.142,0.943 L0.138,0.94 L0.135,0.938 L0.131,0.935 L0.128,0.933 L0.124,0.93 L0.121,0.928 L0.117,0.925 L0.114,0.922 L0.11,0.92 L0.107,0.917 L0.104,0.914 L0.101,0.911 L0.098,0.908 L0.095,0.905 L0.092,0.902 L0.089,0.899 L0.086,0.896 L0.083,0.893 L0.08,0.89 L0.078,0.886 L0.075,0.883 L0.072,0.879 L0.07,0.876 L0.067,0.872 L0.065,0.869 L0.062,0.865 L0.06,0.862 L0.057,0.858 L0.055,0.854 L0.053,0.85 L0.051,0.846 L0.049,0.842 L0.046,0.838 L0.044,0.834 L0.042,0.83 L0.04,0.826 L0.039,0.821 L0.037,0.817 L0.035,0.813 L0.033,0.808 L0.031,0.803 L0.03,0.799 L0.028,0.794 L0.026,0.789 L0.025,0.784 L0.023,0.779 L0.022,0.774 L0.021,0.769 L0.019,0.764 L0.018,0.759 L0.017,0.753 L0.015,0.748 L0.014,0.742 L0.013,0.736 L0.012,0.73 L0.011,0.724 L0.01,0.718 L0.009,0.712 L0.008,0.706 L0.007,0.699 L0.007,0.693 L0.006,0.686 L0.005,0.679 L0.004,0.671 L0.004,0.664 L0.003,0.656 L0.003,0.648 L0.002,0.64 L0.002,0.631 L0.001,0.622 L0.001,0.613 L0.001,0.603 L0.001,0.592 L0,0.58 L0,0.568 L0,0.553 L0,0.535 L0,0.5 L0,0.465 L0,0.447 L0,0.432 L0,0.42 L0.001,0.408 L0.001,0.397 L0.001,0.387 L0.001,0.378 L0.002,0.369 L0.002,0.36 L0.003,0.352 L0.003,0.344 L0.004,0.336 L0.004,0.329 L0.005,0.321 L0.006,0.314 L0.007,0.307 L0.007,0.301 L0.008,0.294 L0.009,0.288 L0.01,0.282 L0.011,0.276 L0.012,0.27 L0.013,0.264 L0.014,0.258 L0.015,0.252 L0.017,0.247 L0.018,0.241 L0.019,0.236 L0.021,0.231 L0.022,0.226 L0.023,0.221 L0.025,0.216 L0.026,0.211 L0.028,0.206 L0.03,0.201 L0.031,0.197 L0.033,0.192 L0.035,0.187 L0.037,0.183 L0.039,0.179 L0.04,0.174 L0.042,0.17 L0.044,0.166 L0.046,0.162 L0.049,0.158 L0.051,0.154 L0.053,0.15 L0.055,0.146 L0.057,0.142 L0.06,0.138 L0.062,0.135 L0.065,0.131 L0.067,0.128 L0.07,0.124 L0.072,0.121 L0.075,0.117 L0.078,0.114 L0.08,0.11 L0.083,0.107 L0.086,0.104 L0.089,0.101 L0.092,0.098 L0.095,0.095 L0.098,0.092 L0.101,0.089 L0.104,0.086 L0.107,0.083 L0.11,0.08 L0.114,0.078 L0.117,0.075 L0.121,0.072 L0.124,0.07 L0.128,0.067 L0.131,0.065 L0.135,0.062 L0.138,0.06 L0.142,0.057 L0.146,0.055 L0.15,0.053 L0.154,0.051 L0.158,0.049 L0.162,0.046 L0.166,0.044 L0.17,0.042 L0.174,0.04 L0.179,0.039 L0.183,0.037 L0.187,0.035 L0.192,0.033 L0.197,0.031 L0.201,0.03 L0.206,0.028 L0.211,0.026 L0.216,0.025 L0.221,0.023 L0.226,0.022 L0.231,0.021 L0.236,0.019 L0.241,0.018 L0.247,0.017 L0.252,0.015 L0.258,0.014 L0.264,0.013 L0.27,0.012 L0.276,0.011 L0.282,0.01 L0.288,0.009 L0.294,0.008 L0.301,0.007 L0.307,0.007 L0.314,0.006 L0.321,0.005 L0.329,0.004 L0.336,0.004 L0.344,0.003 L0.352,0.003 L0.36,0.002 L0.369,0.002 L0.378,0.001 L0.387,0.001 L0.397,0.001 L0.408,0.001 L0.42,0 L0.432,0 L0.447,0 L0.465,0 L0.5,0 L0.535,0 L0.553,0 L0.568,0 L0.58,0 L0.592,0.001 L0.603,0.001 L0.613,0.001 L0.622,0.001 L0.631,0.002 L0.64,0.002 L0.648,0.003 L0.656,0.003 L0.664,0.004 L0.671,0.004 L0.679,0.005 L0.686,0.006 L0.693,0.007 L0.699,0.007 L0.706,0.008 L0.712,0.009 L0.718,0.01 L0.724,0.011 L0.73,0.012 L0.736,0.013 L0.742,0.014 L0.748,0.015 L0.753,0.017 L0.759,0.018 L0.764,0.019 L0.769,0.021 L0.774,0.022 L0.779,0.023 L0.784,0.025 L0.789,0.026 L0.794,0.028 L0.799,0.03 L0.803,0.031 L0.808,0.033 L0.813,0.035 L0.817,0.037 L0.821,0.039 L0.826,0.04 L0.83,0.042 L0.834,0.044 L0.838,0.046 L0.842,0.049 L0.846,0.051 L0.85,0.053 L0.854,0.055 L0.858,0.057 L0.862,0.06 L0.865,0.062 L0.869,0.065 L0.872,0.067 L0.876,0.07 L0.879,0.072 L0.883,0.075 L0.886,0.078 L0.89,0.08 L0.893,0.083 L0.896,0.086 L0.899,0.089 L0.902,0.092 L0.905,0.095 L0.908,0.098 L0.911,0.101 L0.914,0.104 L0.917,0.107 L0.92,0.11 L0.922,0.114 L0.925,0.117 L0.928,0.121 L0.93,0.124 L0.933,0.128 L0.935,0.131 L0.938,0.135 L0.94,0.138 L0.943,0.142 L0.945,0.146 L0.947,0.15 L0.949,0.154 L0.951,0.158 L0.954,0.162 L0.956,0.166 L0.958,0.17 L0.96,0.174 L0.961,0.179 L0.963,0.183 L0.965,0.187 L0.967,0.192 L0.969,0.197 L0.97,0.201 L0.972,0.206 L0.974,0.211 L0.975,0.216 L0.977,0.221 L0.978,0.226 L0.979,0.231 L0.981,0.236 L0.982,0.241 L0.983,0.247 L0.985,0.252 L0.986,0.258 L0.987,0.264 L0.988,0.27 L0.989,0.276 L0.99,0.282 L0.991,0.288 L0.992,0.294 L0.993,0.301 L0.993,0.307 L0.994,0.314 L0.995,0.321 L0.996,0.329 L0.996,0.336 L0.997,0.344 L0.997,0.352 L0.998,0.36 L0.998,0.369 L0.999,0.378 L0.999,0.387 L0.999,0.397 L0.999,0.408 L1,0.42 L1,0.432 L1,0.447 L1,0.465 L1,0.5 Z" })
    ])
  ])
], -1)

import { PropType, computed, onMounted, ref, useSlots, watch } from "vue";
/**
 * Пропсы
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-icon-view',
  props: {
  /**
   * Скруглен полностью
   */
  isRounded: { type: Boolean as PropType<boolean>, default: false },
  /**
   * С границей, которая срабатывает на ховер
   */
  isBordered: { type: Boolean as PropType<boolean>, default: true },
  /**
   * Размер
   */
  size: { type: Number as PropType<number>, default: 138 },
  /**
   * Картинка срабатывающая по условию в fallback
   */
  imageLoadUrl: { type: String as PropType<string>, default: null },

  /**
   * Картинка срабатывающая по условию в fallback
   */
  colorCode: { type: String as PropType<string> },
},
  setup(__props) {

const props = __props;



/**
 * Слоты
 */
const slots = useSlots();

/**
 * Состояние загрузки фотки
 */
const isLoadingLocal = ref(false);

/**
 * Произошла ли ошибка при загрузке фотки (404, 500)
 */
const isErrorRequestForFoto = ref(false);

/**
 * Есть ли иконка внутри или фотка
 */
const mainSlot = computed(() => slots && slots.mainSlot && slots.mainSlot());

/**
 * Расчет размеров и классов
 */
const calculateClassesSizes = computed(() => {
  return {
    "icon-view--circle": props.isRounded,
    "icon-view--is-loading-image": isLoadingLocal.value,
    "icon-view--xxxl": props.size / 16 <= 8 && props.size / 16 >= 6.063,
    "icon-view--xxl": props.size / 16 <= 6 && props.size / 16 >= 5.063,
    "icon-view--xl": props.size / 16 <= 5 && props.size / 16 >= 4.063,
    "icon-view--l": props.size / 16 <= 4 && props.size / 16 >= 3.563,
    "icon-view--m": props.size / 16 <= 3.5 && props.size / 16 >= 3.063,
    "icon-view--s": props.size / 16 <= 3 && props.size / 16 >= 2.563,
    "icon-view--xs": props.size / 16 <= 2.5 && props.size / 16 >= 2.063,
    "icon-view--xxs": props.size / 16 <= 2 && props.size / 16 >= 1.5,
  };
});

const computedImageLoadUrl = computed(() => props.imageLoadUrl);

watch(computedImageLoadUrl, () => {
  checkLoadImage();
});

const checkLoadImage = () => {
  if (computedImageLoadUrl.value) {
    const img = new Image();
    img.onload = () => {
      isErrorRequestForFoto.value = false;
    };
    img.onerror = () => {
      console.error('Ошибка при загрузке изображения', computedImageLoadUrl.value);
      isErrorRequestForFoto.value = true;
    };
    img.src = computedImageLoadUrl.value;
  }
};
onMounted(async () => {
  checkLoadImage();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.isBordered)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["icon-view-border-background", {
        'icon-view-border-background--circle': props.isRounded,
      }])
        }, null, 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["icon-view", [calculateClassesSizes.value, `icon-view--${props.colorCode}`]]),
      style: _normalizeStyle({
        width: props.size / 16 + 'rem',
        background: `${props.colorCode} !important`,
      })
    }, [
      (mainSlot.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["icon-view__main-slot", {
          'icon-view__main-slot--loading': props.imageLoadUrl && isLoadingLocal.value,
        }])
          }, [
            _renderSlot(_ctx.$slots, "mainSlot"),
            (
              props.imageLoadUrl && !isLoadingLocal.value && !isErrorRequestForFoto.value
            )
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: _normalizeClass(["icon-view__image", {
              'icon-view__image--loaded': !isLoadingLocal.value,
            }]),
                  src: props.imageLoadUrl
                }, null, 10, _hoisted_2))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      _hoisted_3
    ], 6),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})